import toast from "react-hot-toast";
import i18next from "i18next";
import {BaseClient} from "../../Api/HttpClient";

export const createMailHistorySlice = (set, get) => ({
    mailHistory: [],
    mailMetaData: {},
    getMailHistory: async (data = {}) => {
        const mailParams = new URLSearchParams();

        if(data.hasOwnProperty('shiftId')){
            mailParams.append('shift_id', data.shiftId);
        }

        if(data.hasOwnProperty('freelancerId')){
            mailParams.append('freelancer_id', data.freelancerId);
        }

        if(data.hasOwnProperty('customerId')){
            mailParams.append('customer_id', data.customerId);
        }

        if(data.hasOwnProperty('page')){
            mailParams.append('page', data.page);
        }

        try {
            const response = await BaseClient().get(`/mail-history?${mailParams.toString()}`);
            if (response.status === 200) {
                const mailData = response.data.data || response.data;
                set({mailHistory: mailData});
                set({mailMetaData: response.data.meta || {}});
                return mailData;
            } else {
                toast.error(response.data.message || i18next.t('mail_history.toast_fetch_error'));
            }
        } catch (error) {
            console.error('Error fetching mail history:', error);
            toast.error(i18next.t('mail_history.toast_fetch_error'));
            throw error;
        }
    }
})